var menuItems = document.querySelectorAll('.card-header-tabs>li');
for (var i = 0; i < menuItems.length; i++) {
    menuItems[i].addEventListener("click", function(ev){
        // Don't change the url
        ev.preventDefault();

        // occulting divs - removing .active class
        var tabs = document.querySelectorAll('.tab-content>.tab-pane');
        for (var k = 0; k < tabs.length; k++) {
            tabs[k].classList.remove("active");
        }

        // removing .active from menu items
        for (var j = 0; j < menuItems.length; j++) {
            menuItems[j].getElementsByTagName("A")[0].classList.remove("active");
        }

        // adding .active in clicked item
        this.getElementsByTagName("A")[0].classList.add("active");

        // getting target id
        var linkTab = this.getElementsByTagName("A")[0].attributes['aria-controls'].value;

        // showing the selected tab div
        var tab = document.querySelectorAll('.tab-content>'+linkTab)[0];
        tab.classList.add("active");
    });
};

